/**
 * Blogbilder gibt es in 1200 px und als schmale Variante mit 640 px (Dateiname mit -640).
 * Handys laden so ein Viertel der Datenmenge. Das Vorrendern bricht ab, wenn eine Variante fehlt.
 */
export const schmal = (url: string) => url.replace(/\.avif$/, '-640.avif');
export const srcSet = (url: string) => `${schmal(url)} 640w, ${url} 1200w`;
